module.exports = __webpack_public_path__ + "static/media/profile.44eb4ede.jpg";